import type { components } from '@/types/api.generated';

export type AnalyticsSyncHealth = components['schemas']['AnalyticsSyncHealth'];
export type AnalyticsReportSummary = components['schemas']['AnalyticsReportSummary'];
export type AnalyticsReportDetail = components['schemas']['AnalyticsReportDetail'];
export type AnalyticsMetrics = AnalyticsReportDetail['metrics'];
export type AnalyticsSyncStatus = Exclude<AnalyticsSyncHealth['latest_status'], null>;
export type AnalyticsPeriodKind = AnalyticsReportSummary['period_kind'];

export const ANALYTICS_SYNC_STATUS = {
  running: 'running',
  succeeded: 'succeeded',
  failed: 'failed',
} as const satisfies Record<string, AnalyticsSyncStatus>;

export const ANALYTICS_PERIOD_KIND = {
  weekly: 'weekly',
  adhoc: 'adhoc',
} as const satisfies Record<string, AnalyticsPeriodKind>;

export interface AnalyticsReportArchive {
  items: AnalyticsReportSummary[];
  sync: AnalyticsSyncHealth;
}
